import React, { useState, useEffect } from "react";
import { DataTable, Filter, PageWrapper } from "../../components";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Pages } from "../../shared/enums";
import { useTranslation } from "react-i18next";
import { getDriverList } from "../../api/driver";
import { RiAddLargeLine } from "react-icons/ri";
import Button from '../../components/common/Button';

const Driver = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [filter, setFilter] = useState({});
  const [pagination, setPagination] = useState({ page: 1, pageSize: 25 });
  const [totalPages, setTotalPage] = useState(0);
  const [data, setData] = useState([]);

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setPagination(prev => ({ ...prev, page: 1 })); // Reset to page 1 when filter changes
  };

  const columns = [
    { key: "fullName", label: t("FULL_NAME") },
    {
      key: "phoneNumber",
      label: t("PHONE_NUMBER"),
      render: (phoneNumber, data) => data.countryCode + data.phoneNumber,
    },
    { key: "email", label: t("EMAIL") },
    { key: "gender", label: t("GENDER") },
    { key: "referenceNumber", label: t("REFERENCE_NUMBER") },
    { key: "driverType", label: t("DRIVER_TYPE") },
    { key: "serviceArea", label: t("SERVICE_AREA"), render: (serviceArea) => serviceArea || "-" },
    { key: "emergencyContactName", label: t("EMERGENCY_CONTACT_NAME") },
    {
      key: "emergencyContactPhoneNumber",
      label: t("EMERGENCY_CONTACT"),
      render: (phoneNumber, data) => {
        if (!data.emergencyContactCountryCode || !data.emergencyContactPhoneNumber) {
          return "-";
        }
        return data.emergencyContactCountryCode + data.emergencyContactPhoneNumber;
      },
    },
    {
      key: "suspended",
      label: t("SUSPENDED"),
      render: (suspended) => (suspended ?? '').toString(),
    },
    {
      key: "action",
      label: t("ACTION"),
      render: (v, data) => (
        <Dropdown>
          <Dropdown.Toggle
            variant="primary"
            size="sm"
            className="py-0"
          ></Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() =>
                navigate(Pages.DriverDetail.replace(":id", data.id))
              }
            >
              {t("DETAIL")}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => navigate(Pages.DriverWallet.replace(":id", data.id))}
            >
              {t("WALLET")}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => navigate(Pages.DriverDetailTierDetail.replace(":id", data.id))}
            >
              {t("TIER")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
  ];

  const filters = [
    { type: "input", label: t("SEARCH"), name: "search" },
    {
      type: "select",
      label: t("SUSPENDED"),
      name: "suspended",
      options: [
        { label: "All", value: "" },
        { label: "Yes", value: true },
        { label: "No", value: false },
      ],
    },
  ];

  useEffect(() => {
    getData(pagination, filter);
  }, [pagination, filter]);

  const getData = async (pagination, filter) => {
    const response = await getDriverList({
      skip: (pagination?.page - 1) * pagination?.pageSize,
      limit: pagination?.pageSize,
      ...filter,
    });
    setData(response.items);
    setTotalPage(Math.ceil(response?.pagination?.total / pagination?.pageSize));
  };

  return (
    <PageWrapper
      headerProps={{
        title: "DRIVER",
        rightElement: <Button
          icon={<RiAddLargeLine />}
          onClick={() => navigate(Pages.DriverForm.replace(":id", "new"))}
        >
          {t("ADD")}
        </Button>
      }}
    >
      <Filter filters={filters} onChangeFilter={handleFilterChange} />
      <DataTable
        columns={columns}
        data={data}
        pagination={{ ...pagination, totalPages, onChange: setPagination }}
      />
    </PageWrapper>
  );
};

export default Driver;
